// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1LZpa","load3":"Spinner_load3__32wqx"};